import { type Enum } from '@webapp/utils'

export const IntegrationSetupStates = {
  INACTIVE: 'inactive',
  AWAITING_CONFIGURATION: 'awaitingConfiguration',
  ACTIVE: 'active',
  CONFIGURING: 'configuring',
  DISABLED: 'disabled',
  INITIALIZING: 'initializing',
  DISCONNECTED: 'disconnected',
} as const

export type IntegrationSetupState = Enum<typeof IntegrationSetupStates>
